const translations = {
  title: 'New Checklist',
  title_edit: 'Editing Checklist',
  'questionsStep.title': 'Category and questions',
  'questionsStep.subtitle': 'Build the checklist structure',
  'fieldsStep.name': 'Name',
  'fieldsStep.type': 'Type',
  'fieldsStep.title': 'Basic Info',
  'fieldsStep.subtitle': 'Fill the checklist info',
  'fieldsStep.allowReview': 'Allow review based on last task',
  'fieldsStep.sendEmail': 'Send notification email when completing checklist',
  'fieldsStep.usages': 'I will use this checklist in',
  'fieldsStep.description': 'Description',
  'fieldsStep.icon': 'Icon',
  'fieldsStep.requireCheckin': `Require place's QR Code validation to execute this checklist on the app`,
  'fieldsStep.allowBulkExecution': 'Allow bulk execution',
  'fieldsStep.allowBulkExecutionConditionalLogicHint':
    'Checklists enabled for bulk execution cannot use conditional logic.',
  'fieldsStep.allowBulkExecutionConditionalLogicBlocked':
    '🚨 This checklist has questions with logic configured. To allow bulk execution, you must remove all logic from the checklist. After making the adjustment, come back and enable this option again.',
  'fieldsStep.setRuntime': 'Runtime for this checklist',
  'fieldsStep.enabledSegwareTestMode': 'Enable Segware Test Mode',
  'fieldsStep.segwarePermittedExecutionTime': 'Test mode runtime',
  'fieldsStep.calendarViewActive': 'Add background color to calendar view',
  'fieldsStep.calendarViewBgColor': 'Select the color',
  usageForm: 'Forms',
  usageServiceOrder: 'Service Orders',
  usageActionPlan: 'Action Plan',
  dragQuestionsHere: 'Drag questions here',
  addCategory: 'Add Category',
  clone: 'Clone',
  remove: 'Remove',
  question: 'Question',
  questionSettings: 'Question Settings',
  required: 'Required',
  requiredDocument: 'Required document',
  useSavedUserSignature: 'Pre-fill with user profile signature',
  confidential: 'Confidential',
  allowNA: 'Allow N/A',
  allowOnlyQrCodeOperations: 'Allow only QR Code operations',
  displayAsDropdown: 'Display as dropdown',
  allowMultipleSelection: 'Allow multiple selection',
  noLineBreak: 'Do not allow line break',
  useMarkdown: 'Use markdown',
  dontAllowReview: 'Do not allow review',
  filterByActivityPlace: 'Filter by activity place',
  annotations: 'Annotations',
  allowAnnotations: 'Allow annotations',
  requiredAnnotations: 'Required annotations',
  'validationCode.title': 'Validation',
  'validationCode.validateWithParentId': 'Validate using the parent activity ID',
  filterByAdditionalField: 'Filter by Additional Field',
  selectAdditionalField: 'Select the additional field',
  selectOperator: 'Select the operator',
  value: 'Value',
  addFilter: 'Add filter',
  additionalField: 'Additional field',
  removeFilter: 'Remove filter',
  folder: 'Folder',
  noFolder: 'No folder',
  calcWarning: 'This type of question cannot be used between different categories or inside blocks.',
  'operator.equal': 'Equal to',
  'operator.notEqual': 'Not equal to',
  'operator.greaterThan': 'Greater than',
  'operator.lessThan': 'Less than',
  'operator.lessThanOrEqual': 'Less than or equal to',
  'operator.greaterThanOrEqual': 'Greater than or equal to',
  validationNameRequired: 'Name required',
  validationSelectUsage: 'Select how you want to use the checklist',
  validationSelectType: 'Select the checklist type',
  validationSelectCalendarColor: 'Select the background color for the calendar event',
  validationAddAtLeastOneCategory: 'Please add at least one category',
  validationGroupsWithoutCategory: 'Checklist has groups without selected category',
  validationCategoriesWithoutQuestions: 'Categories cannot be without questions',
  validationQuestionsWithoutLabel: 'Checklist has questions without label',
  validationInvalidConditions:
    'Checklist has logic or non-compliance configuration with options that no longer exist. Check Single Selection and Multiple Choice questions.',
  validationQuestionsWithoutOptions: 'Checklist has selection or multiple choice questions without options',
  validationEmptyBlocks: 'Empty block questions are not allowed',
  validationBlocksInBlocks: 'Blocks inside blocks are not allowed',
  validationEmptyCalc: 'Checklist has calculation questions without formula',
  validationEmptyIntegration: 'Checklist has integration questions without configuration',
  selectCategory: 'Select a category',
  selectQuestionToEdit: 'Select a question to edit it',
  categoryLabel: 'category',
  questionLabel: 'question',
  'removeModal.multipleAutomationsAffected':
    'The following automations will be affected by removing the {{removingType}}',
  'removeModal.singleAutomationAffected': 'The following automation will be affected by removing the {{removingType}}',
  'removeModal.confirmContinue': 'Are you sure you want to continue?',
  'removeModal.removeCategoryWarning':
    'By removing this category, all linked questions will be deleted. Are you sure you want to continue?',
  ifAnswerIs: 'If the answer is:',
  addLogic: 'Add logic',
  addLogicBlockedByBulkExecution:
    'Checklists enabled for bulk execution cannot use conditional logic between questions.',
  updateLogic: 'Update logic',
  multipleChoiceOptions: 'Multiple choice options',
  questionInfo: 'Question information',
  description: 'Description',
  fileOrImage: 'File or Image',
  add: 'Add',
  noCategoryDefined: 'No category defined',
  defaultValue: 'Default value',
  removeDefaultValue: 'Remove default value',
  calculation: 'Calculation',
  formula: 'Formula',
  calcNote: 'Note: Use numbers with the following pattern',
  calcMinFieldsRequired: 'At least 2 numeric fields are required to get a result.',
  numericSettings: 'Numeric settings',
  minValue: 'Minimum value',
  maxValue: 'Maximum value',
  labels: 'Labels',
  'labels.yesNo': 'Yes/No',
  'labels.compliant': 'Compliant',
  'labels.nonCompliant': 'Non-Compliant',
  'labels.compliantNonCompliant': 'Compliant/Non-Compliant',
  'labels.approved': 'Approved',
  'labels.rejected': 'Rejected',
  'labels.approvedRejected': 'Approved/Rejected',
  'labels.positive': 'Positive',
  'labels.negative': 'Negative',
  'labels.positiveNegative': 'Positive/Negative',
  photoSettings: 'Photo settings',
  minQuantity: 'Min quantity',
  allowPhotos: 'Allow photos',
  requiredPhotos: 'Required photos',
  allowGalleryPhotos: 'Allow gallery photos',
  configurationTags: 'Configuration tags',
  filters: 'Filters',
  isNonComplianceWhenAnswerIs: 'Is non-compliance when answer is:',
  removeConfiguration: 'Remove configuration',
  configureMask: 'Configure mask',
  integration: 'Integration',
  service: 'Service',
  field: 'Field',
  operationType: 'Operation type',
  legacyQuestionTypeTitle: 'Deprecated question type!',
  legacyQuestionTypeMessage: 'To get the same result, choose a **Text** type question and apply the desired **Mask**.',
  questionNumber: 'Question #{{number}}',
  addQuestionLabel: 'Add question label...',
  containsLogic: 'Contains logic',
  questionWithNonComplianceConfig: 'Question with non-compliance configuration',
  predefinedDefaultValue: 'Predefined default value',
  questionsRemaining: '🚨 You can still add **{{remaining}}** of **{{total}}** questions',
  previewMessage: 'Would you like to see how the final form will look?',
  preview: 'Preview',
  selectTemplate: 'Select a template',
  'autofill.title': 'Automatic fill',
  'autofill.dataSource': 'Data source',
  'autofill.sourceUser': 'User profile',
  'autofill.sourcePlace': 'Place/Location record',
  'autofill.sourceServiceOrder': 'Activity/Service order fields',
  'autofill.selectSource': 'Select source',
  'autofill.field': 'Field (source)',
  'autofill.editable': 'Editable field',
  'autofill.updateBase': 'Update in base',
  'autofill.updateBaseWarning': 'Changes made by the technician in the app will update the user or place record.',
  'autofill.removeConfig': 'Remove automatic fill'
}

export default translations
